import {EMarkdownType, markdown} from './markdownHelper';

export const blockMarkdown = (
    src: string,
) => markdown(src, EMarkdownType.BLOCK);
